import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = loading, false = anon
    const bootstrap = useCallback(async () => {
        const token = localStorage.getItem("sudigi_token");
        if (!token) { setUser(false); return; }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (e) {
            localStorage.removeItem("sudigi_token");
            setUser(false);
        }
    }, []);

    useEffect(() => { bootstrap(); }, [bootstrap]);

    const login = (token, u) => {
        localStorage.setItem("sudigi_token", token);
        setUser(u);
    };
    const logout = () => {
        localStorage.removeItem("sudigi_token");
        setUser(false);
    };

    return <AuthContext.Provider value={{ user, setUser, login, logout, refresh: bootstrap }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
